import UDASearch from "../../components/UDASearch/UDASearch";
import Footer from "../../components/footer/footer.component";

export const Search = () => {
  return (
    <main className="flex flex-col w-full font-roboto items-start h-full overflow-y-auto parent-container">
      <div className={`flex flex-col w-full justify-center main-search-block`}>
        <span className="py-8 space-y-3">
          {/* Title */}
          <h1 className="text-[#222222] text-5xl font-bold search-title">
            ¿Cuánto vale mi casa?
          </h1>
          {/* Subtitle */}
          <h2 className="text-[#222222] text-2xl search-subtitle">
            Valoración gratuita de inmuebles
          </h2>
          {/* Description */}
          <h3 className="text-[#3E3E3E]">
            Introduce la dirección o la referencia catastral del inmueble para
            realizar una simulación de tasación online gratis y en pocos
            minutos.
          </h3>
        </span>
        {/* Search for address */}
        <div className="flex desktop:flex-row flex-col pb-4">
          <UDASearch />
        </div>
      </div>
      <Footer />
    </main>
  );
};

export default Search;
